// Lightweight app logger with env gating + safe redaction
type Level = "debug" | "info" | "warn" | "error";
const isProd = process.env.NODE_ENV === "production";
const verbose = process.env.NEXT_PUBLIC_VERBOSE_LOGS === "true";

const scrub = (meta: any) => {
  if (!meta) return undefined;
  const out: any = {};
  const keep = (k: string, v: any) => { out[k] = v ?? null; }; // preserve keys as null
  keep("client", meta.client);
  keep("url", meta.url);
  keep("method", meta.method);
  keep("status", meta.status);
  keep("statusText", meta.statusText);
  keep("code", meta.code);
  keep("message", meta.message);
  if (meta.headers && meta.headers["x-request-id"]) {
    out.headers = { "x-request-id": meta.headers["x-request-id"] };
  }
  return out;
};

// Optional: wire to Sentry/Logtail/etc.
const sendToRemote = (level: Level, message: string, meta?: any) => {
  // Example: Sentry.captureMessage(message, { level, extra: meta });
};

const log = (level: Level, message: string, meta?: any) => {
  const safe = scrub(meta);
  if (!isProd || verbose) {
    // eslint-disable-next-line no-console
    console[level](`[${level.toUpperCase()}] ${message}`, safe ?? "");
  }
  if (isProd) sendToRemote(level, message, safe);
};

export const logger = {
  debug: (m: string, meta?: any) => log("debug", m, meta),
  info:  (m: string, meta?: any) => log("info", m, meta),
  warn:  (m: string, meta?: any) => log("warn", m, meta),
  error: (m: string, meta?: any) => log("error", m, meta),
};
